import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";

import { getDisplayName, getUserName } from "@multiweb/reactCore/auth";
import { createOpenFormAction, FormOpenMethod } from "@multiweb/reactCore/bridge";
import { EMPTY_OBJECT } from "@multiweb/reactUtils";
import { IAppState, NoneOwnProps } from "@multiweb/types/react";
import { getInjectedComponentOnRender, ReplaceableComponentNames } from "../../customization/internalIndex";
import { UserMenuComponentProps } from "../UserMenuComponent";

type StateProps = Pick<UserMenuComponentProps, "title" | "userName"> ;

const mapStateToProps: MapStateToProps<StateProps, NoneOwnProps, IAppState> = (state) => {
    const userDisplayName = getDisplayName(state);
    const userName = getUserName(state);

    return {
        title: userDisplayName ?? userName ?? "",
        userName: userDisplayName && userName ? userName : "",
    };
};

type DispatchProps = Pick<UserMenuComponentProps, "onMenuTitleClick">;

const formName = "FRM.UserProfile.UserProfile";

const mapDispatchToProps: MapDispatchToProps<DispatchProps, NoneOwnProps> = (dispatch) => ({
    onMenuTitleClick: () => dispatch(createOpenFormAction(formName, FormOpenMethod.newOrExisting, EMPTY_OBJECT)),
});

export const UserMenu = connect(mapStateToProps, mapDispatchToProps)(getInjectedComponentOnRender(ReplaceableComponentNames.UserMenuComponent));
